// extracted by mini-css-extract-plugin
export default {"selectorWrapper":"styles_selectorWrapper__45kdx"};